
// import card from "../../assets/CaseStudy/card.png";
// import hoverCard from "../../assets/CaseStudy/HoverCard.png";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";



// Container animation for mobile/tablet
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.1,
        },
    },
};

// Card animation for mobile/tablet with border effect
const mobileCardVariants = {
    hidden: {
        opacity: 0,
        y: 30,

    },
    visible: {
        opacity: 1,
        y: 0,

        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
};

export default function CaseFeatures({ features, content }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.2 });
    return (
        <section className="py-12 md:py-16 lg:py-20 px-3 sm:px-6 md:px-12 lg:px-24 sm:mb-6  bg-secondary-50">
            <div className="sm:mx-auto md:max-w-7xl px-4 sm:px-6" ref={ref}>



                <h3 className="font-semibold  text-xl sm:text-lg mb-6 md:mb-8">Key Features</h3>

                <motion.p className="text-gray-600 max-w-6xl mb-8 md:mb-12 font-secondary text-base md:text-xl "
                    initial={{ opacity: 1, y: 10 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 1, y: 10 }}
                    transition={{ duration: 0.6 }}
                >
                    {content}
                </motion.p>

                {/* MOBILE/TABLET DESIGN */}
                <motion.div
                    className="flex flex-wrap gap-4 sm:gap-6 md:gap-8 lg:hidden"
                    variants={containerVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                >
                    {features.map((item, index) => (
                        <motion.div
                            key={index}
                            variants={mobileCardVariants}
                            className="
                w-full
                sm:w-[calc(50%-12px)]
            "
                        >

                            <div
                                className="
                    relative overflow-hidden
                    rounded-3xl
                    p-[1px]
                    bg-gradient-to-br
                    from-blue-500/40
                    via-purple-500/30
                    to-cyan-500/40
                "
                            >

                                <div
                                    className="
                        relative
                        rounded-3xl
                        bg-white
                        px-5 py-6
                        h-full
                        shadow-lg
                    "
                                >

                                    {/* Glow */}
                                    <div className="absolute top-0 right-0 w-24 h-24 bg-blue-200/30 blur-3xl rounded-full" />

                                    {/* Number */}
                                    <div className="mb-4">
                                        <span className="text-4xl font-bold text-gray-200">
                                            0{index + 1}
                                        </span>
                                    </div>

                                    {/* Title */}
                                    <h4 className="text-xl font-semibold text-gray-800 mb-3 font-secondary">
                                        {item.title}
                                    </h4>

                                    {/* Content */}
                                    <p className="text-gray-600 text-sm leading-6">
                                        {item.content}
                                    </p>

                                </div>

                            </div>

                        </motion.div>
                    ))}
                </motion.div>





                {/* DESKTOP DESIGN */}
                <div className="hidden lg:flex flex-col gap-24 ">

                    {features.map((item, index) => (

                        <div
                            key={index}
                            className={`
                flex items-center justify-between gap-10 w-full
                ${index % 2 !== 0 ? "flex-row-reverse" : "flex-row"}
            `}
                        >

                            {/* IMAGE */}
                            <div className="w-1/2 flex justify-center">

                                <div className="relative group">

                                    {/* Background Shape */}
                                    <div
                                        className="
                            absolute
                            inset-0
                            bg-primary-100
                            rounded-[50px]
                            rotate-6
                            scale-95
                            transition-all duration-500
                            group-hover:rotate-[17deg]
                            group-hover:scale-100
                        "
                                    />

                                    {/* Image */}
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="
                            relative z-10
                            w-[500px]
                            h-[350px]
                            object-cover
                            rounded-[40px]
                            shadow-2xl
                            transition-all duration-500
                            group-hover:-translate-y-3
                        "
                                    />

                                </div>

                            </div>

                            {/* CONTENT */}
                            <div className="w-1/3 translate-">

                                <div className="max-w-lg">

                                    {/* Tag */}
                                    {/* <span className=" inline-block px-4 py-1 rounded-full bg-primary-100
                            text-primary-500 text-sm  font-medium mb-5 ">
                                        Feature {index + 1}
                                    </span> */}

                                    {/* Title */}
                                    <h2
                                        className="
                            text-3xl
                            font-bold
                            text-secondary-500
                            leading-tight
                            mb-6
                            font-secondary
                        "
                                    >
                                        {item.title}
                                    </h2>

                                    {/* Description */}
                                    <p
                                        className="
                            text-gray-600
                            text-lg
                            leading-9
                            mb-8
                        "
                                    >
                                        {item.content}
                                    </p>




                                </div>

                            </div>

                        </div>

                    ))}

                </div>

            </div>
        </section>
    );
}


